//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Container, Grid, CircularProgress } from '@material-ui/core';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ScheduleIcon from '@material-ui/icons/Schedule';

import ArrowBack from '@material-ui/icons/ArrowBack';

import optionSrc from '../../images/advertise/option.png';
import optionSrc2 from '../../images/advertise/option2.png';
import optionSrc3 from '../../images/advertise/option3.png';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { BASE_URL, PRICE_ADVERTISEMENT_PLACEMENT } from '../../common/constants';
import { PATH_ADVERTISE } from '../../system/constants';
// import { createAdCheckoutSession } from '../../common/services/paymentServices';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import adPlacementPicture from '../../images/advertise/adPlacementBg.png';
// import { makePlacementsOnHold } from '../../common/services/adServices';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
// import AfitdTextField from '../../common/elemental/AfitdTextField';
import AfitdButton from '../../common/elemental/AfitdButton';
import AfitdMessageDialog from '../../common/elemental/AfitdMessageDialog';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import format from 'date-fns/format';
// import _getTime from 'date-fns/getTime';
// import addMinutes from 'date-fns/addMinutes';

import _get from 'lodash/get';
import { releaseAllPlacementOnHold } from '../../common/services/adServices';
// import _map from 'lodash/map';
// import _join from 'lodash/join';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: { padding: 20 },
    exampleWithNoPropsOnlyStyles: { color: 'red', marginTop: 30, marginBottom: 40 },
    nonReactElementExample: { color: 'blue', marginTop: 50, cursor: 'pointer' },
    container: {
        width: '100%',
        // height: '640px',
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '48px 112px 48px 112px',
        // [theme.breakpoints.down('md')]: { padding: '44px 44px' },
        [theme.breakpoints.down('sm')]: { padding: '44px 16px' },
    },
    heading: {
        fontSize: '26px',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    subHeading: {
        fontSize: '14px',
        textAlign: 'center',
        marginTop: '8px',
        color: '#111E14',
    },
    portionHeading: {
        fontWeight: 'bold',
        fontSize: '20px',
        lineHeight: '23px',
    },
    portionBody: {
        background: '#FFFFFF',
        border: '1px solid #D5D7DD',
        borderRadius: '8px',
        width: '100%',
        padding: '24px',
    },
    portionBodyBottom: {
        background: '#FFFFFF',
        border: '1px solid #D5D7DD',
        borderRadius: '8px',
        padding: '8px',
        // height: '243px',
        marginRight: '10px',
    },
    label: {
        fontSize: '14px',
        lineHeight: '14px',
        marginBottom: '0px',
    },
    itemValue: {
        fontWeight: 'bold',
        fontSize: '16px',
        // lineHeight: '28px',
        marginTop: '10px',
        marginBottom: '5px',
    },
    iconItem: {
        display: 'flex',
        // alignItems: 'center',
    },
    itemIcon: {
        marginRight: '8px',
        color: '#9B9E9C',
        marginTop: '13px',
        fontSize: '20px',
    },
    title: {
        fontSize: '20px',
        position: 'relative',
        top: '3px',
    },
    desktopImage: {
        height: '100%',
        width: '100%',
        borderRadius: '6px',
        backgroundColor: '#f5f5f5',
        textAlign: 'center',
    },
    mobileImage: {
        height: '80px',
        width: '100%',
        borderRadius: '6px',
        backgroundColor: '#f5f5f5',
        textAlign: 'center',
        paddingTop: '40px',
    },
    backButton: {
        textAlign: 'left',
    },
    buttonsDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        marginTop: '50px',
    },
    gridBody2: {
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    pricingDiv: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#f5f5f5',
        borderRadius: '8px',
        padding: '2px',
        textAlign: 'center',
        width: '100%',
        height: '90px',
    },
    smallSub: {
        position: 'relative',
        top: '10px',
        left: '37px',
    },
    orange: {
        color: '#FC821F',
    },
    gridBodyTires: {
        [theme.breakpoints.down('sm')]: { flexDirection: 'column' },
    },
    mobileGrid: {
        [theme.breakpoints.down('sm')]: { display: 'flex', justifyContent: 'center' },
    },
    priceGridItemIcon: { display: 'flex', justifyContent: 'flex-end' },
    termsAndConditionContainer: { display: 'flex', paddingTop: 10, marginLeft: '-11px' },
    reCaptchaContainer: {},
    reCaptchaError: { color: '#f44336 !important', marginTop: '5px', fontSize: '0.75rem', marginLeft: '15px' },
    termsAndConditionText: { fontWeight: 'bold' },
    termsOfConditionLink: {
        color: '#374EF5',
        textDecoration: 'underline',
        fontWeight: 'bold',
    },
    container1: {
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        border: '2px solid #D5D7DD',
        marginTop: '20px',
    },
    container2: {
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        border: '2px solid #D5D7DD',
        marginTop: '20px',
    },
    container3: {
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        border: '2px solid #D5D7DD',
        marginTop: '20px',
    },
    qualities: {
        // position: 'relative',
        // top: '-1px',
        // left: '16px',
        paddingLeft: '10px',
    },
    features: {
        fontSize: '14px',
        marginBottom: '20px',
    },
    featureBody: {
        marginTop: '6px',
        display: 'flex',
    },
    contentBody: {
        marginLeft: '10px',
        marginTop: '20px',
    },
    listBody: {
        marginLeft: '-28px',
    },
    placementAdSection: {
        position: 'absolute',
        width: '228px',
        height: '228px',
        top: '65px',
        right: '13px',
        backgroundImage: `URL(${adPlacementPicture})`,
        backgroundSize: 'cover',
        // background: 'rgba(29, 138, 139, 0.06)',
        // border: `1px dashed ${theme.palette.secondary.main}`,
    },
    placementBlock: {
        padding: '30px',
        textAlign: 'center',
        height: '114px',
        // border: `1px dashed ${theme.palette.secondary.main}`,
    },
    placementNumber: {
        lineHeight: '30px',
        fontSize: '25px',
        borderRadius: '50%',
        paddingTop: '10px',
        width: '50px',
        height: '50px',
        margin: 'auto',
        background: theme.palette.secondary.main,
        color: 'white',
        // paddingLeft: '18px',
        boxShadow: '0px 4px 4px 0px #00000040',
    },
    placementAvailbiltyText: {
        fontSize: '18px',
        marginTop: '15px',
        color: '#9B9E9C',
        fontWeight: 'bold',
    },
    adPlacementPicture: {
        position: 'relative',
    },
    optionImage: {
        width: '100%',
        marginTop: '15px',
        position: 'absolute',
    },
    adImage: {
        width: '100%',
        borderRadius: '8px',
    },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        // history,
        handleClickBackButton,
        handleNext,
        unavailablePlacementDialogOpen,
        handleOnCloseModal,
        backButtonLoading,
    } = params;

    const defns = {
        helloText: { variant: 'h4' },
        textFieldExample: { value: 'Hello TextField' },
        nonReactElementExample: {
            onClick: evt => {
                alert('Clicked!');
            },
        },
        gridBody: { container: true, spacing: 1, justifyContent: 'space-between', alignItems: 'center' },
        gridBodyAdPage: { container: true, spacing: 1, justifyContent: 'space-between', alignItems: 'baseline' },
        gridBodyTires: { container: true, spacing: 1 },
        gridBody2: { container: true },
        gridItem: { xs: 12, lg: 6 },
        gridItemShort: { xl: 2, lg: 2, md: 3, sm: 6, xs: 6 },
        gridItemIcon: { xl: 4, lg: 4, md: 4, sm: 4, xs: 12 },
        priceGridItemIcon: { xl: 4, lg: 4, md: 4, sm: 5, xs: 5 },
        itemGrid: { item: true, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },
        optionImage: {
            src: optionSrc,
            style: {
                width: '100%',
                marginTop: '15px',
            },
        },
        optionImage2: {
            src: optionSrc2,
            style: {
                width: '100%',
                marginTop: '15px',
            },
        },
        optionImage3: {
            src: optionSrc3,
            style: {
                width: '100%',
                marginTop: '15px',
            },
        },
        desktopGrid: {
            item: true,
            xl: 6,
            lg: 6,
            md: 6,
            sm: 12,
            xs: 12,
        },
        mobileGrid: {
            item: true,
            xl: 3,
            lg: 3,
            md: 4,
            sm: 12,
            xs: 12,
        },
        nextButton: {
            color: 'primary',
            onClick: handleNext,
            // disabled: loading,
        },
        backButton: {
            onClick: handleClickBackButton,
            disabled: backButtonLoading,
        },

        availabilityGrid: {
            container: true,
            spacing: 2,
            // alignItems: 'center',
        },
        availabilityitemGrid: { item: true, xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
        itemGrid2: { item: true, xl: 4, lg: 4, md: 4, sm: 6, xs: 6 },

        placementGridContainer: {
            container: true,
            alignItems: 'center',
            justifyContent: 'center',
        },
        placementGridRow: {
            item: true,
            xs: 12,
        },
        placementGrid: {
            container: true,
            alignItems: 'center',
            justifyContent: 'center',
        },
        placementBlock: {
            item: true,
            xs: 6,
        },
        unavailablePlacementDialog: {
            title: 'Your Selected Placement is no Longer Available!',
            children: (
                <AfitdTypography>The Placement you selected for you Ad is currently unavailable, Please select a different placement or select another Date/Time</AfitdTypography>
            ),
            open: unavailablePlacementDialogOpen,
            onClose: handleOnCloseModal,
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
let isDevMode = false;
window.location.hostname === 'localhost' ? (isDevMode = true) : (isDevMode = false);

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const Step4Page = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const history = useHistory();

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    const layoutContext = useContext(LayoutContext);
    const {
        scrollToPageTop,
        customerData,
        checkState,
        adImageUrl,
        jobCenterAdDetails,
        talentCenterAdDetails,
        employerSearchAdDetails,
        onHoldDocIds,
        setOnHoldDocIds,
        setCheckedAvailability,
        setShowTimer,
        setHideJobCenterList,
        setHideTalentCenterList,
        setHideEmpSearchList,
        // setSnackbarMessage,
        setSnackbarErrorMessage,
        // setOnHoldDocIds,
        // setCheckedAvailability,
        // setJobCenterAdDetails,
        setJobCenterPlacementData,
        setTalentCenterPlacementData,
        // setTalentCenterAdDetails,
        // setEmployerSearchAdDetails,
        setEmpSearchPlacementData,
        setPaymentIntentDescription,
    } = layoutContext;
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;
    const adCusId = _get(customerData, 'adCusId', null);

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [loading, setLoading] = React.useState(false);
    const [backButtonLoading, setBackButtonLoading] = React.useState(false);
    const [unavailablePlacementDialogOpen, setUnavailablePlacementDialogOpen] = React.useState(false);

    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // on mount, scroll to the top of the page
    useEffect(() => {
        scrollToPageTop();
    }, [scrollToPageTop]);

    useEffect(() => {
        if (!adCusId) history.push(`${BASE_URL}${PATH_ADVERTISE}/start`);
        // don't need to run multiple Times
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    let totalPrice = 0;
    if (checkState.jobCtr) totalPrice = totalPrice + PRICE_ADVERTISEMENT_PLACEMENT;
    if (checkState.talentCtr) totalPrice = totalPrice + PRICE_ADVERTISEMENT_PLACEMENT;
    if (checkState.empSearch) totalPrice = totalPrice + PRICE_ADVERTISEMENT_PLACEMENT;

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleOnCloseModal = () => {
        setUnavailablePlacementDialogOpen(false);
        history.push(`${BASE_URL}${PATH_ADVERTISE}/step3`);
    };

    const handleClickBackButton = async () => {
        setBackButtonLoading(true);
        const status = await releaseAllPlacementOnHold({ onHoldDocIds, setSnackbarErrorMessage });

        if (status === 'success') {
            setCheckedAvailability({ jobCtr: false, talentCtr: false, empSearch: false });
            setOnHoldDocIds([]);
            localStorage.setItem('onHoldEndDt', null);
            setShowTimer(false);
            setPaymentIntentDescription('');
            setHideJobCenterList(true);
            setHideTalentCenterList(true);
            setHideEmpSearchList(true);
            setJobCenterPlacementData();
            setTalentCenterPlacementData();
            setEmpSearchPlacementData();
            history.push(`${BASE_URL}${PATH_ADVERTISE}/step3`);
        }

        setBackButtonLoading(false);
    };

    const handleNext = async () => {
        history.push(`${BASE_URL}${PATH_ADVERTISE}/step5`);

        //---------------------------------------------------------------------
        // since we have a 5-minute timer and Stripe Checkout session only allows setting expiration
        //   at least 30 minutes after creation OR immediate expiring, we cannot use Stripe Checkout. -el 20220910
        //---------------------------------------------------------------------
        // const resp = await createAdCheckoutSession({ email: adCusEmail, quantity: 2 });
        // if (resp) {
        //     const checkoutUrl = _get(resp, 'data.url');
        //     window.location.href = checkoutUrl;
        // }
    };

    const TimeSlotComponent = props => {
        const { data } = props;
        const { placement, date, time } = data;
        return (
            <div>
                <div {...defns.portionBody}>
                    <Grid {...defns.gridBody}>
                        <Grid {...defns.gridItemIcon}>
                            <p {...defns.label}>Placement</p>
                            <p {...defns.itemValue}>{placement}</p>
                        </Grid>

                        <Grid {...defns.gridItemIcon}>
                            <div {...defns.iconItem}>
                                <div>
                                    <CalendarTodayIcon {...defns.itemIcon} />
                                </div>
                                <div>
                                    <p {...defns.label}>Date</p>
                                    <p {...defns.itemValue}>{format(new Date(date), 'MM/dd/yyyy')}</p>
                                </div>
                            </div>
                        </Grid>
                        <Grid {...defns.gridItemIcon}>
                            <div {...defns.iconItem}>
                                <div>
                                    <ScheduleIcon {...defns.itemIcon} />
                                </div>
                                <div>
                                    <p {...defns.label}>Time</p>
                                    <p {...defns.itemValue}>{format(time, 'p')}</p>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    };

    const PlacementGrid = props => {
        const { activePlacement } = props;
        const arr = [...Array(4)].map((_, i) => i + 1);
        return (
            <div {...defns.placementAdSection}>
                <Grid {...defns.placementGridContainer}>
                    {arr?.map(el => (
                        <Grid {...defns.placementBlock}>{activePlacement === el && <AfitdTypography {...defns.placementNumber}>{el}</AfitdTypography>}</Grid>
                    ))}
                </Grid>
            </div>
        );
    };
    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        props,
        history,
        checkState,
        isDevMode,
        handleClickBackButton,
        handleNext,
        unavailablePlacementDialogOpen,
        handleOnCloseModal,
        backButtonLoading,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <Container {...defns.container}>
                <div {...defns.heading}>Submit AD Request</div>
                {/* <div {...defns.subHeading}>You will only be charged if approved</div> */}
                <div>
                    <p {...defns.portionHeading}>Information About You</p>
                    <div {...defns.portionBody}>
                        <Grid {...defns.gridBody}>
                            <Grid {...defns.gridItem}>
                                <p {...defns.label}>Company Name:</p>
                                <p {...defns.itemValue}>{customerData?.companyName}</p>
                            </Grid>
                            <Grid {...defns.gridItem}>
                                <p {...defns.label}>Email Address:</p>
                                <p {...defns.itemValue}>{customerData?.email}</p>
                            </Grid>
                            <Grid {...defns.gridItem}>
                                <p {...defns.label}>Headquarters/Head Office Location:</p>
                                <p {...defns.itemValue}>{customerData?.country}</p>
                            </Grid>
                            <Grid {...defns.gridItem}>
                                <p {...defns.label}>State:</p>
                                <p {...defns.itemValue}>{customerData?.state}</p>
                            </Grid>
                            <Grid {...defns.gridItem}>
                                <p {...defns.label}>City:</p>
                                <p {...defns.itemValue}>{customerData?.city}</p>
                            </Grid>
                            <Grid {...defns.gridItem}>
                                <p {...defns.label}>Telephone:</p>
                                <p {...defns.itemValue}>{customerData?.phone}</p>
                            </Grid>
                            <Grid {...defns.gridItem}>
                                <p {...defns.label}>Point of contact:</p>
                                <p {...defns.itemValue}>{customerData?.poc}</p>
                            </Grid>
                        </Grid>
                    </div>
                </div>
                <br />
                <p {...defns.portionHeading}>Where and When</p>
                {checkState?.jobCtr && (
                    <div>
                        <div {...defns.container1}>
                            <Grid {...defns.gridBodyAdPage}>
                                <Grid {...defns.itemGrid}>
                                    <div>
                                        <span {...defns.title}>
                                            <b>Job Center</b> (${PRICE_ADVERTISEMENT_PLACEMENT} - 30 minutes)
                                        </span>
                                    </div>
                                    <div {...defns.contentBody}>
                                        <p {...defns.features}>Advertising Specifics:</p>
                                        <ul {...defns.listBody}>
                                            <li>
                                                <div {...defns.featureBody}>
                                                    <span variant="body2" {...defns.qualities}>
                                                        Ad space will be available in quadrants.
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div {...defns.featureBody}>
                                                    <span {...defns.qualities}>Your Ad will likely share display space with other advertisers..</span>
                                                </div>
                                            </li>
                                            <li>
                                                <div {...defns.featureBody}>
                                                    <span {...defns.qualities}>
                                                        Your Ad will display on page load for 30 minutes to all users of this page for the date/time selected. Once search criteria
                                                        is entered and a search is executed, the results will display on the left side of the page. Your Ad will still display. Once
                                                        a record is selected/clicked upon, then the details will display on the right side and all Ads will no longer display until
                                                        the page is refreshed / reloaded during the paid for time-frame.
                                                    </span>
                                                </div>
                                            </li>
                                            <br />
                                            <li>
                                                <div {...defns.featureBody}>
                                                    <span {...defns.qualities}>
                                                        Ads will not display in our Native App. Only in the web app in larger viewports due to lack of space.
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </Grid>
                                <Grid {...defns.itemGrid} {...defns.adPlacementPicture}>
                                    <img alt="" {...defns.optionImage} />
                                    <PlacementGrid activePlacement={parseInt(jobCenterAdDetails?.placement)} />
                                </Grid>
                            </Grid>
                        </div>
                        <br />
                        <TimeSlotComponent data={jobCenterAdDetails} />
                    </div>
                )}

                <br />
                {checkState?.talentCtr && (
                    <div>
                        <div {...defns.container2}>
                            <Grid {...defns.gridBodyAdPage}>
                                <Grid {...defns.itemGrid}>
                                    <div>
                                        <span {...defns.title}>
                                            <b>Talent Center</b> (${PRICE_ADVERTISEMENT_PLACEMENT} - 30 minutes)
                                        </span>
                                    </div>
                                    <div {...defns.contentBody}>
                                        <p {...defns.features}>Advertising Specifics:</p>
                                        <ul {...defns.listBody}>
                                            <li>
                                                <div {...defns.featureBody}>
                                                    <span variant="body2" {...defns.qualities}>
                                                        Ad space will be available in quadrants.
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div {...defns.featureBody}>
                                                    <span {...defns.qualities}>Your Ad will likely share display space with other advertisers..</span>
                                                </div>
                                            </li>
                                            <li>
                                                <div {...defns.featureBody}>
                                                    <span {...defns.qualities}>
                                                        Your Ad will display on page load for 30 minutes to all users of this page for the date/time selected. Once search criteria
                                                        is entered and a search is executed, the results will display on the left side of the page. Your Ad will still display. Once
                                                        a record is selected/clicked upon, then the details will display on the right side and all Ads will no longer display until
                                                        the page is refreshed / reloaded during the paid for time-frame.
                                                    </span>
                                                </div>
                                            </li>
                                            <br />
                                            <li>
                                                <div {...defns.featureBody}>
                                                    <span {...defns.qualities}>
                                                        Ads will not display in our Native App. Only in the web app in larger viewports due to lack of space.
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </Grid>
                                <Grid {...defns.itemGrid} {...defns.adPlacementPicture}>
                                    <img alt="" {...defns.optionImage} />
                                    <PlacementGrid activePlacement={parseInt(talentCenterAdDetails?.placement)} />
                                </Grid>
                            </Grid>
                        </div>{' '}
                        <br />
                        <TimeSlotComponent data={talentCenterAdDetails} />
                    </div>
                )}

                <br />
                {checkState?.empSearch && (
                    <div>
                        <div {...defns.container3}>
                            <Grid {...defns.gridBodyAdPage}>
                                <Grid {...defns.itemGrid}>
                                    <div>
                                        <span {...defns.title}>
                                            <b>Employer Search</b> (${PRICE_ADVERTISEMENT_PLACEMENT} - 30 minutes)
                                        </span>
                                    </div>
                                    <div {...defns.contentBody}>
                                        <p {...defns.features}>Advertising Specifics:</p>
                                        <ul {...defns.listBody}>
                                            <li>
                                                <div {...defns.featureBody}>
                                                    <span variant="body2" {...defns.qualities}>
                                                        Ad space will be available in quadrants.
                                                    </span>
                                                </div>
                                            </li>
                                            <li>
                                                <div {...defns.featureBody}>
                                                    <span {...defns.qualities}>Your Ad will likely share display space with other advertisers..</span>
                                                </div>
                                            </li>
                                            <li>
                                                <div {...defns.featureBody}>
                                                    <span {...defns.qualities}>
                                                        Your Ad will display on page load for 30 minutes to all users of this page for the date/time selected. Once search criteria
                                                        is entered and a search is executed, the results will display on the left side of the page. Your Ad will still display. Once
                                                        a record is selected/clicked upon, then the details will display on the right side and all Ads will no longer display until
                                                        the page is refreshed / reloaded during the paid for time-frame.
                                                    </span>
                                                </div>
                                            </li>
                                            <br />
                                            <li>
                                                <div {...defns.featureBody}>
                                                    <span {...defns.qualities}>
                                                        Ads will not display in our Native App. Only in the web app in larger viewports due to lack of space.
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </Grid>
                                <Grid {...defns.itemGrid} {...defns.adPlacementPicture}>
                                    <img alt="" {...defns.optionImage} />
                                    <PlacementGrid activePlacement={parseInt(employerSearchAdDetails?.placement)} />
                                </Grid>
                            </Grid>
                        </div>
                        <br />
                        <TimeSlotComponent data={employerSearchAdDetails} />
                    </div>
                )}

                <div>
                    <p {...defns.portionHeading}>AD Image</p>
                    <Grid {...defns.gridBody}>
                        <Grid {...defns.desktopGrid}>
                            <div {...defns.portionBodyBottom}>
                                {adImageUrl ? <img src={adImageUrl} alt="ad" {...defns.adImage} /> : <div {...defns.desktopImage}>Desktop Image here</div>}
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div>
                    <p {...defns.portionHeading}>Purchase Summary</p>
                    <div {...defns.portionBody}>
                        <Grid {...defns.gridBody2}>
                            <Grid {...defns.gridItemIcon}>
                                {checkState?.jobCtr && <p {...defns.itemValue}>Job Center</p>}
                                {checkState?.talentCtr && <p {...defns.itemValue}>Talent Center</p>}
                                {checkState?.empSearch && <p {...defns.itemValue}>Employer Search</p>}
                            </Grid>
                            <Grid {...defns.priceGridItemIcon}>
                                <div {...defns.pricingDiv}>
                                    <p {...defns.label}>Total Price:</p>
                                    <p {...defns.itemValue}>${parseFloat(totalPrice).toFixed(2)}</p>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
                <div {...defns.buttonsDiv}>
                    <div>
                        <AfitdButton {...defns.backButton}>
                            {!backButtonLoading && <ArrowBack fontSize="small" />}
                            {backButtonLoading ? <CircularProgress size={25} /> : ' Back'}
                        </AfitdButton>
                    </div>
                    <div>
                        {/* <AfitdButton {...defns.nextButton}>
                            {loading ? <CircularProgress size={25} /> : 'Proceed to Payment'}
                            {` `}
                        </AfitdButton> */}
                        <AfitdButton {...defns.nextButton}>Proceed to Payment</AfitdButton>
                    </div>
                </div>
            </Container>
            <AfitdMessageDialog {...defns.unavailablePlacementDialog} />
        </div>
    );
};

export default Step4Page;
